import type { CSSObject } from '@emotion/react'
import {
  Color,
  OppositeTheme,
  Spacing,
  Transition,
  Typography,
} from '@opallabs/gem'
import type { StyleProps } from '../types'

export const container: CSSObject = {
  alignItems: 'center',
  display: 'flex',
  gap: Spacing.S,
  justifyContent: 'flex-end',
}

const roundedContainer: CSSObject = {
  alignItems: 'center',
  blockSize: Spacing.XS * 9,
  borderRadius: Spacing.XL,
  boxSizing: 'border-box',
  borderStyle: 'solid',
  borderWidth: Spacing.XS / 2,
  display: 'flex',
  justifyContent: 'center',
  minInlineSize: Spacing.XS * 9,
}

const pill = ({ theme }: StyleProps): CSSObject => ({
  ...roundedContainer,
  backgroundColor: Color[theme].Translucent.N72,
  borderColor: Color[OppositeTheme[theme]].Surface.N000,
  opacity: 0.7,
  ...Transition(['opacity']),

  '&:hover': {
    opacity: 1,
  },

  '@media (prefers-contrast: more)': {
    opacity: 1,
  },
})

export const controls = ({ theme }: StyleProps): CSSObject => ({
  ...pill({ theme }),
  listStyle: 'none',
})

export const positionInDeck = ({ theme }: StyleProps): CSSObject => ({
  ...pill({ theme }),
  color: Color[theme].Text.Default,
  ...Typography.H100,
  paddingBlock: Spacing.XS,
})

export const control: CSSObject = {
  '& + &': {
    marginInlineStart: Spacing.S,
  },
}

export const controlButton: CSSObject = {
  inlineSize: Spacing.XS * 8,

  '&, &::before': {
    borderRadius: '50%',
  },
}
